export { default as onAddendumLifecycle } from './lifecycle';
